/**
 * Round half-up to 2 decimals — matches backend rounding, unlike toFixed().
 * Usage: round2(1.585) === 1.59
 */
export const round2 = (n) => {
  const num = Number(n);
  if (!isFinite(num)) return 0;
  return Math.round((num + Number.EPSILON) * 100) / 100;
};

/** Same, but returns a Number for API payloads */
export const money = (n) => round2(n);
